(() => {
    const capcod = window.capcod;
    if (!capcod) return;

    const reduceMotion = capcod.reduceMotion;
    const DESKTOP = 920;

    const stage = document.querySelector('.hero-showcase-stage');
    if (stage && !reduceMotion) {
        const cols = Array.from(stage.querySelectorAll('.hsc-col'));
        const originals = cols.map((col) => Array.from(col.children));
        const clone = (n) => {
            const c = n.cloneNode(true);
            c.setAttribute('aria-hidden', 'true');
            c.querySelectorAll('a, [tabindex]').forEach((el) => el.setAttribute('tabindex', '-1'));
            return c;
        };

        let mode = null;
        const build = () => {
            const next = window.innerWidth > DESKTOP ? 'desktop' : 'mobile';
            if (next === mode) return;
            mode = next;

            stage.querySelectorAll('.hsc-loop').forEach((l) => l.remove());
            cols.forEach((col, i) => col.replaceChildren(...originals[i]));

            if (next === 'desktop') {
                cols.forEach((col, i) => {
                    if (!originals[i].length) return;
                    const extra = originals[i].map(clone);
                    if (i === 0) extra.forEach((c) => col.appendChild(c));
                    else extra.reverse().forEach((c) => col.insertBefore(c, col.firstChild));
                });
            } else {
                const all = originals.flat();
                if (!all.length) return;
                const loop = document.createElement('div');
                loop.className = 'hsc-loop';
                loop.setAttribute('aria-hidden', 'true');
                stage.style.setProperty('--hero-marquee-dur', Math.max(24, all.length * 5) + 's');
                all.forEach((n) => loop.appendChild(clone(n)));
                stage.appendChild(loop);
            }
        };
        build();
        window.addEventListener('resize', build);
    }

    const hero = document.querySelector('.hero');
    const ribbons = document.querySelector('[data-ribbons]');
    const blobs = ribbons ? ribbons.querySelectorAll('.ribbon-blob') : [];
    const col1 = document.querySelector('[data-hsc-col="1"]');
    const col2 = document.querySelector('[data-hsc-col="2"]');

    if (!reduceMotion && (ribbons || col1 || col2)) {
        capcod.onScrollWhileVisible(hero, (y) => {
            if (ribbons) {
                ribbons.style.transform = `translate3d(0, ${y * 0.32}px, 0)`;
                blobs.forEach((b, i) => { b.style.transform = `translate3d(0, ${y * (0.12 + i * 0.1)}px, 0)`; });
            }
            if (col1 || col2) {
                if (window.innerWidth > DESKTOP) {
                    const p = Math.max(0, Math.min(260, y * 0.32));
                    if (col1) col1.style.transform = `translateY(${-p}px)`;
                    if (col2) col2.style.transform = `translateY(${p}px)`;
                } else {
                    if (col1) col1.style.transform = '';
                    if (col2) col2.style.transform = '';
                }
            }
        });
    }

})();
